import { type MenuResponse } from '@on3/api/src';
import { Link } from '@on3/ui-lib/components/Link';
import { Tag } from '@on3/ui-lib/components/Tag';
import { parseMenuTitle } from '@on3/ui-lib/utils/parsers';

import styles from './TrendingMenu.module.scss';

export const TrendingMenu = ({ data }: { data: MenuResponse[] }) => {
  return (
    <nav className={styles.block}>
      <ul className={styles.list}>
        {data.map((item) => {
          const { title, tag } = parseMenuTitle(item.title);

          return (
            <li className={styles.item} key={item.id}>
              <Link href={item.url}>
                {tag && <Tag type={tag} />}
                {title}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};
